import { render, staticRenderFns } from "./locale-select.vue?vue&type=template&id=af348ffa"
import script from "./locale-select.vue?vue&type=script&lang=js"
export * from "./locale-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports